import './banner.css';
import React from 'react';






function Banner() {

  return (
    <div className='banner'>
      <div className="banner-area banner-area-3">
        <div className="banner-slider slider-control-round owl-carousel">
              <div  className='item bg-overlay'>
                <div className="container">
                  <div className="row justify-content-center">
                    <div className="col-lg-9">
                      <div className="banner-inner style-white text-center">
                        <h4 className="sub-title s-animate-1">مـــركــــز</h4>
                        <h1 className="title s-animate-2">دكتور كار لصيانة السيارات</h1>
                        <p className="content s-animate-3">تركيب مكائن مستوردة مع الضمان - توضيب قير - تركيب قير - بيع مكائن مستوردة لجميع السيارات - مكانيكا لجميع السيارات</p>
                        <div className="btn-wrap s-animate-4">
                        <a className="it-btn btn-base mr-space" href="tel:0552092011" rel="noopener noreferrer"> <i className="fas fa-phone pr2" ></i> إتصل الأن </a> 
                        <a className="it-btn btn-black" href="https://maps.app.goo.gl/6si4kQ46iMae3YPp9" rel="noopener noreferrer" target="_blank"> <i className="fas fa-map-marker-alt pr"></i> إلى الموقع </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
        </div>
      </div>
    </div>
  );
}

export default Banner;
